module.exports = __webpack_public_path__ + "static/media/Primate-House2.55361b71.jpg";